export default __webpack_public_path__ + "static/media/AB-testiranje.fea5aea8.gif";